module.exports = __webpack_public_path__ + "img/CR.41a8307b.svg";